export default function manageMessage( input, message, status ) {
  const formGroup = input.closest( '.form-group' );

  console.log( input, formGroup )

  switch ( status ) {
  case 'success':
    insertMarkup( formGroup, message, status )
    break;
  case 'danger':
    insertMarkup( formGroup, message, status )
    break;
  default:
  }
}

function insertMarkup( parent, text, colour ) {
  const
    message = parent.querySelector( 'small' ),
    small = document.createElement( 'small' );

  if ( message ) {
    message.classList.forEach( className => {
      if ( className.startsWith( 'form-group__msg--' )) {
        message.classList.remove( className )
      }
    })
    parent.classList.forEach( className => {
      if ( className.startsWith( 'form-group--has-' )) {
        parent.classList.remove( className )
      }
    })
    message.classList.add( `form-group__msg--${ colour }` );
    parent.classList.add( `form-group--has-${ colour }` );
    message.innerText = text;
  } else {
    small.classList.add( 'form-group__msg', `form-group__msg--${ colour }` );
    small.innerText = text;
    parent.classList.add( `form-group--has-${ colour }` );
    parent.appendChild( small );
  }
}
